const baseUrl = "/v1/admin/interest-discovery";

export const apiUrls = {
  list: `${baseUrl}`,
  create: `${baseUrl}/create`,
  uplodefile: `${baseUrl}/verify`,
  importfile: `${baseUrl}/import`,
  update: (id: number): string => `${baseUrl}/${id}/update`,
  delete: (id: number): string => `${baseUrl}/${id}/delete`,
  details: (id: number): string => `${baseUrl}/${id}/details`,
  bulkUpdate: `${baseUrl}/bulk-update`,
  changeStatus: (id: number): string => `${baseUrl}/${id}/change-status`,
  changeOrder: `${baseUrl}/change-order`,
  careerCategories: `/v1/career-categories`,
  occupationalGroups: `/v1/occupational-groups`,
};
